import { VideoplayerSchemeDefinition } from "./videoplayer-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createVideoplayerMapDefinition } from "../../../utils/scheme-helper";

export const VIDEOPLAYER_TYPE_FILE = "file";
export const VIDEOPLAYER_TYPE_YOUTUBE = "youtube";
export const VIDEOPLAYER_TYPE_MOVING_IMAGE = "moving-image";

export const VIDEOPLAYER_TYPES = [
  VIDEOPLAYER_TYPE_FILE,
  VIDEOPLAYER_TYPE_YOUTUBE,
  VIDEOPLAYER_TYPE_MOVING_IMAGE
] as const;

export const VIDEOPLAYER_ORIENTATION_PORTRAIT = "portrait";
export const VIDEOPLAYER_ORIENTATION_LANDSCAPE = "landscape";
export const VIDEOPLAYER_ORIENTATION = [VIDEOPLAYER_ORIENTATION_PORTRAIT, VIDEOPLAYER_ORIENTATION_LANDSCAPE] as const;

function createSchemes() {
  let newSchemes: AllColors.VideoplayerSchemeConfiguration<VideoplayerSchemeDefinition> = {};
  AllColors.VIDEOPLAYER_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      color: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      playButtonColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const VIDEOPLAYER_SCHEME_CONFIG: AllColors.VideoplayerSchemeConfiguration<VideoplayerSchemeDefinition> = createSchemes();

export const VIDEOPLAYER_SCHEME_MAP: Map<BackgroundColor | "default", VideoplayerSchemeDefinition> = new Map(
  Object.entries(createVideoplayerMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    VIDEOPLAYER_SCHEME_CONFIG[config as string]
  ])
);
